<script>
  import { onMount, getContext, createEventDispatcher } from 'svelte'
  import * as L from 'leaflet'
  import markerIcons, { ICON_TYPES, ICON_SIZES} from './markerIcons';

  export let lat, lng
  export let size = ICON_SIZES.md
  export let image = null
  export let active = false
  export let focusOnSelect = false
  export let riseOnHover = false

  const dispatch = createEventDispatcher()
  const { getMap, paddedRenderer } = getContext('map')
  const map = getMap()
  $: latlng = [lat, lng]
  $: iconType = (image && size !== ICON_SIZES.xs && size !== ICON_SIZES.sm) ? ICON_TYPES.image : ICON_TYPES.circle
  $: sizedImage = image ? image.getSize('xxs') : null
  $: icon = markerIcons[iconType]({ size, active, imageUrl: sizedImage ? sizedImage.src : null })
  const marker = L.marker(latlng, { icon, riseOnHover, renderer: paddedRenderer })

  $: {
    marker
      .setIcon(icon)
      .setZIndexOffset(active ? 1000 : 0)
  }

  $: marker.setLatLng(latlng)

  $: if (focusOnSelect && active && !map.getBounds().contains(latlng)) {
    map.panTo(latlng)
  }

  onMount(() => {
    map.addLayer(marker)
    marker.on('click', () => dispatch('click'))

    return () => {
      map.removeLayer(marker)
    }
  })
</script>

<style>
    :global(.map-marker-circle) {
        border-radius: 50%;
        border: 2px solid var(--color-grey-xdark);
        background: var(--color-white);
    }

    :global(.map-marker-circle--active) {
        background: var(--color-primary-dark);
    }

    :global(.map-marker-image) {
        border-color: var(--color-white);
        object-fit: cover;
    }

    :global(.map-marker-image--active) {
        border-color: var(--color-primary-dark);
    }

    :global(.map-marker-circle--xs) {
        border-width: 2px;
        width: 8px;
        height: 8px;
    }
    :global(.map-marker-circle--sm) {
        border-width: 2px;
        width: 16px;
        height: 16px;
    }
    :global(.map-marker-circle--md) {
        border-width: 3px;
        width: 30px;
        height: 30px;
    }
    :global(.map-marker-circle--lg) {
        border-width: 3px;
        width: 50px;
        height: 50px;
        opacity: var(--opacity-mid);
    }
    :global(.map-marker-circle--xl) {
        border-width: 4px;
        width: 80px;
        height: 80px;
        opacity: var(--opacity-mid);
    }

    :global(.map-marker-circle--active.map-marker-circle--lg) {
        opacity: var(--opacity-dark);
    }

    :global(.map-marker-circle--active.map-marker-circle--xl) {
        opacity: var(--opacity-dark);
    }

    :global(.map-marker-circle.map-marker-image) {
        opacity: var(--opacity-dark);
    }

</style>
